import {
    Box,
    Chip,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';
import { useState } from 'react';

const ChipSelect = ({ options, selectedValues, onChange, label }) => {
    const [open, setOpen] = useState(false);

    const handleToggle = (value) => {
        const newSelectedValues = selectedValues.includes(value)
            ? selectedValues.filter((v) => v !== value)
            : [...selectedValues, value];
        onChange(newSelectedValues);
    };

    const handleClear = () => {
        onChange([]);
    };

    return (
        <FormControl fullWidth size="small">
            <InputLabel>{label}</InputLabel>
            <Select
                multiple
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                value={selectedValues}
                onChange={(e) => onChange(e.target.value)}
                label={label}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => {
                            const option = options.find((opt) => opt.value === value);
                            return (
                                <Chip
                                    key={value}
                                    label={option ? option.label : value}
                                    size="small"
                                    sx={{
                                        backgroundColor: option ? option.bgcolor : 'default',
                                    }}
                                    color={option ? 'primary' : 'default'}
                                    icon={option && option.icon ? <IconComponent iconName={option.icon} style={{ color: 'white', fontSize: 16 }} /> : null}
                                />
                            );
                        })}
                    </Box>
                )}
                endAdornment={
                    selectedValues.length > 0 && (
                        <IconButton
                            size="small"
                            onClick={handleClear}
                            sx={{ marginRight: 2 }}
                        >
                            <IconComponent iconName="close" style={{ fontSize: 16 }} />
                        </IconButton>
                    )
                }
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value} onClick={() => handleToggle(option.value)}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {option.icon && <IconComponent iconName={option.icon} style={{ marginRight: 8, color: option.bgcolor }} />}
                            <Typography sx={{ color: option.bgcolor }}>{option.label}</Typography>
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default ChipSelect;
